import React__default from 'react';
import { useGetCartExpressPaymentMethods } from './use-get-cart-express-payment-methods.js';
import { useIsApplePayActive } from './use-is-apple-pay-active.js';
import { PaymentMethod } from '../models/cart-payment-methods/cart-payment-methods.js';

const useIsApplePaySupportedForCart = ()=>{
    const isApplePayActive = useIsApplePayActive();
    const [getExpressPaymentMethods, { loading , called , data , error  }] = useGetCartExpressPaymentMethods();
    const getIsApplePaySupportedForCart = React__default.useCallback((cartId)=>{
        if (cartId) {
            getExpressPaymentMethods(cartId);
        }
    }, [
        getExpressPaymentMethods
    ]);
    if (!isApplePayActive) {
        return [
            ()=>undefined
            ,
            {
                isApplePaySupportedForCart: false,
                loading: false,
                called: true,
                error: undefined
            }, 
        ];
    }
    return [
        getIsApplePaySupportedForCart,
        {
            isApplePaySupportedForCart: !!(data === null || data === void 0 ? void 0 : data.find(({ name  })=>name === PaymentMethod.APPLE_PAY
            )),
            loading,
            called,
            error
        }, 
    ];
};

export { useIsApplePaySupportedForCart };
//# sourceMappingURL=use-is-apple-pay-supported-for-cart.js.map
